<p-dialog id="exportdocument"
          [header]="header"
          [appTabTitle]="header"
          [(visible)]="display"
          [modal]="modal"
          [resizable]="false"
          (onShow)="onShowDialog()"
          (onHide)="onHideDialog()"
          [style]="{width: '40vw'}">

  <ng-template pTemplate="content" *ngIf="document">
    <div class="grid mt-2 ml-2">
      <div class="grid">
        <h5>Выбрать печатную форму</h5>
      </div>
      <div *ngFor="let report of reportList" class="grid p-field-checkbox col-12">
          <p-radioButton [inputId]="report.REPORTID" name="report.REPORTID" [label]="report.REPORTNAME" [value]="report" [(ngModel)]="selectedReport"></p-radioButton>
      </div>
    </div>

    <div class="grid p-flex-row mt-2 ">
      <h5>Настройки итогового документа</h5>
      <div class="col-12 grid">
        <div class="p-field-checkbox col-3">
          <p-checkbox [(ngModel)]="countEmpty" [binary]="true" inputId="cem" styleClass="mr-2" (onChange)="onCountEmptyChange($event)"></p-checkbox>
          <label for="sht">Выводить пустные строки</label>
        </div>
        <div class="p-field-checkbox col-3" *ngIf="(document.DOCTYPE == 12)">
          <p-checkbox [(ngModel)]="showCurrency" [binary]="true" inputId="shc" styleClass="mr-2"></p-checkbox>
          <label for="shc">Выгружать в валюте</label>
        </div>
        <div class="p-field-checkbox col-3" *ngIf="(document.DOCTYPE == 12) || (document.DOCTYPE == 1)">
          <p-checkbox [(ngModel)]="showItem" [binary]="true" inputId="shi" styleClass="mr-2" (onChange)="onShowItemChange($event)"></p-checkbox>
          <label for="shi">Показывать состав</label>
        </div>
        <div class="p-field-checkbox col-3" *ngIf="(document.DOCTYPE == 12) || (document.DOCTYPE == 1)">
          <p-checkbox [(ngModel)]="showItemTable" [binary]="true" inputId="sht" styleClass="mr-2" [disabled]="!showItem"></p-checkbox>
          <label for="sht">Состав в отдельной таблице</label>
        </div>
      </div>

      <div class="col-12 grid" *ngIf="(document.DOCTYPE == 1)">
        <div class="p-field-checkbox col-4" *ngIf="false">
          <p-checkbox [(ngModel)]="useDevForm" [binary]="true" inputId="dvf" styleClass="mr-2"></p-checkbox>
          <label for="dvf">Режим разработки</label>
        </div>
        <div class="p-field-checkbox col-4">
          <p-checkbox [(ngModel)]="showLogo" [binary]="true" inputId="shl" styleClass="mr-2"></p-checkbox>
          <label for="shl">Включать логотип</label>
        </div>
        <div class="p-field-checkbox col-4">
          <p-checkbox [(ngModel)]="showStamp" [binary]="true" inputId="shs" styleClass="mr-2"></p-checkbox>
          <label for="shs">Включать печать</label>
        </div>
        <div class="p-field-checkbox col-4">
          <p-checkbox [(ngModel)]="showSign" [binary]="true" inputId="shg" styleClass="mr-2"></p-checkbox>
          <label for="shg">Включать подпись</label>
        </div>
      </div>
      <div class="col-12">
        <div class="fluid">
          <h5>{{exportHeader}}</h5>
          <p-progressBar [value]="value" [style]="{ height: '2rem' }"></p-progressBar>
        </div>
      </div>

    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button label="ОК!" icon="pi pi-check" (click)="onConfirm('ok')" [disabled]="notReady || !printFormSelected"></p-button>
    <p-button label="Отмена" icon="pi pi-times" (click)="display=false"></p-button>
  </ng-template>
</p-dialog>
